<idp-book-widget-search-modal
  [recentSearchList]="recentSearchList"
  [savedSearchList]="savedSearchList"
  [searchModalTabs]="searchModalTabs"
  [predictiveSearchData]="predictiveSearchData"
  [isFullscreen]="isFullscreen"
  [modalOpen]="modalOpen"
  (searchModalClose)="handleSearchModalClose($event)"
  (selectedTabChange)="handleModalEvents({ type: 'tabChange', data: $event })"
  (searchStringChanged)="
    handleModalEvents({ type: 'searchStringChanged', data: $event })
  "
  (savedSearchItemSelected)="
    handleModalEvents({ type: 'saveSearchItemSelected', data: $event })
  "
  (recentSearchItemSelected)="
    handleModalEvents({ type: 'recentSearchItemSelected', data: $event })
  "
  (predictiveSearchItemSelected)="handlePredictiveSearchItemselection($event)"
>
  <mach-multi-route-picker
    idpSwapIconClick
    class="multi-city__route-picker"
    [content]="routePickerContent"
    [cities]="routePickerCities"
    [citySearchResults]="routePickerSearchResult"
    [error]="error"
    [idpErrorState]="error"
    (swapClicked)="swapClicked.emit()"
    (sendSelectedData)="handleRoutePickerClick($event)"
  ></mach-multi-route-picker>
</idp-book-widget-search-modal>
